import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = ["data-theme-dark"]
const _hoisted_3 = { class: "title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")
  const _component_ConversationIcon = _resolveComponent("ConversationIcon")
  const _component_ThreadHeader = _resolveComponent("ThreadHeader")
  const _component_NcRichText = _resolveComponent("NcRichText")
  const _component_NcPopover = _resolveComponent("NcPopover")
  const _component_TasksCounter = _resolveComponent("TasksCounter")
  const _component_CalendarEventsDialog = _resolveComponent("CalendarEventsDialog")
  const _component_CallTime = _resolveComponent("CallTime")
  const _component_IconAccountMultiplePlusOutline = _resolveComponent("IconAccountMultiplePlusOutline")
  const _component_IconAccountMultipleOutline = _resolveComponent("IconAccountMultipleOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_ExtendOneToOneDialog = _resolveComponent("ExtendOneToOneDialog")
  const _component_TopBarMenu = _resolveComponent("TopBarMenu")
  const _component_CallButton = _resolveComponent("CallButton")
  const _component_BreakoutRoomsEditor = _resolveComponent("BreakoutRoomsEditor")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["top-bar", {
			'top-bar--sidebar': $props.isSidebar,
			'top-bar--in-call': $props.isInCall,
			'top-bar--authorised': $options.getUserId,
		}])
  }, [
    _createElementVNode("a", {
      class: _normalizeClass(["top-bar__icon-wrapper", { 'top-bar__icon-wrapper--thread': !$props.isInCall && $setup.threadId }]),
      role: "button",
      tabindex: 0,
      title: $options.conversationIconLabel,
      "aria-label": $options.conversationIconLabel,
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.handleClickAvatar && $options.handleClickAvatar(...args)))
    }, [
      _withDirectives(_createVNode(_component_IconArrowLeft, {
        class: "top-bar__icon-back bidirectional-icon",
        size: 20
      }, null, 512), [
        [_vShow, $setup.threadId]
      ]),
      (_openBlock(), _createBlock(_component_ConversationIcon, {
        key: $options.conversation.token,
        offline: $options.isOffline,
        item: $options.conversation,
        size: !$props.isSidebar ? $setup.AVATAR.SIZE.DEFAULT : $setup.AVATAR.SIZE.COMPACT,
        "disable-menu": false,
        "show-user-online-status": "",
        "hide-favorite": false,
        "hide-call": false
      }, null, 8, ["offline", "item", "size"]))
    ], 10, _hoisted_1),
    (!$props.isInCall && $setup.threadId)
      ? (_openBlock(), _createBlock(_component_ThreadHeader, {
          key: 0,
          class: "top-bar__wrapper"
        }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "top-bar__wrapper",
          "data-theme-dark": $props.isInCall ? true : undefined
        }, [
          _createElementVNode("a", {
            role: "button",
            class: "conversation-header",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.openConversationSettings && $options.openConversationSettings(...args)))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["conversation-header__text", { 'conversation-header__text--offline': $options.isOffline }])
            }, [
              _createElementVNode("p", _hoisted_3, _toDisplayString($options.conversation.displayName), 1),
              ($options.showUserStatusAsDescription)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["description", { 'description__in-chat': !$props.isInCall }])
                  }, _toDisplayString($options.statusMessage), 3))
                : _createCommentVNode("", true),
              ($options.conversation.description)
                ? (_openBlock(), _createBlock(_component_NcPopover, {
                    key: 1,
                    "no-focus-trap": "",
                    delay: 500,
                    boundary: _ctx.boundaryElement,
                    "popper-triggers": ['hover'],
                    triggers: ['hover']
                  }, {
                    trigger: _withCtx(({ attrs }) => [
                      _createElementVNode("p", _mergeProps(attrs, {
                        class: ["description", { 'description__in-chat': !$props.isInCall }]
                      }), _toDisplayString($options.conversation.description), 17)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_NcRichText, {
                        class: "description__popover",
                        text: $options.conversation.description,
                        "use-extended-markdown": ""
                      }, null, 8, ["text"])
                    ]),
                    _: 1
                  }, 8, ["boundary"]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          ($options.conversation.type === $setup.CONVERSATION.TYPE.NOTE_TO_SELF)
            ? (_openBlock(), _createBlock(_component_TasksCounter, { key: 0 }))
            : _createCommentVNode("", true),
          ($options.showCalendarEvents)
            ? (_openBlock(), _createBlock(_component_CalendarEventsDialog, {
                key: 1,
                token: $setup.token
              }, null, 8, ["token"]))
            : _createCommentVNode("", true),
          ($props.isInCall)
            ? (_openBlock(), _createBlock(_component_CallTime, {
                key: 2,
                start: $options.conversation.callStartTime
              }, null, 8, ["start"]))
            : _createCommentVNode("", true),
          ($props.isInCall && $options.isModeratorOrUser)
            ? (_openBlock(), _createBlock(_component_NcButton, {
                key: 3,
                title: $options.participantsInCallAriaLabel,
                "aria-label": $options.participantsInCallAriaLabel,
                class: "top-bar__participants-button",
                variant: "tertiary",
                onClick: _cache[2] || (_cache[2] = $event => ($options.openSidebar('participants')))
              }, _createSlots({
                icon: _withCtx(() => [
                  ($options.canExtendOneToOneConversation)
                    ? (_openBlock(), _createBlock(_component_IconAccountMultiplePlusOutline, {
                        key: 0,
                        size: 20
                      }))
                    : (_openBlock(), _createBlock(_component_IconAccountMultipleOutline, {
                        key: 1,
                        size: 20
                      }))
                ]),
                _: 2
              }, [
                (!$options.canExtendOneToOneConversation)
                  ? {
                      name: "default",
                      fn: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.participantsInCall), 1)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["title", "aria-label"]))
            : (!$props.isSidebar && $options.canExtendOneToOneConversation)
              ? (_openBlock(), _createBlock(_component_ExtendOneToOneDialog, {
                  key: 4,
                  token: $setup.token
                }, null, 8, ["token"]))
              : _createCommentVNode("", true),
          _createVNode(_component_TopBarMenu, {
            token: $setup.token,
            "show-actions": !$props.isSidebar,
            "is-sidebar": $props.isSidebar,
            onOpenBreakoutRoomsEditor: _cache[3] || (_cache[3] = $event => (_ctx.showBreakoutRoomsEditor = true))
          }, null, 8, ["token", "show-actions", "is-sidebar"]),
          (!$props.isInCall)
            ? (_openBlock(), _createBlock(_component_CallButton, {
                key: 5,
                "shrink-on-mobile": ""
              }))
            : _createCommentVNode("", true),
          (_ctx.showBreakoutRoomsEditor)
            ? (_openBlock(), _createBlock(_component_BreakoutRoomsEditor, {
                key: 6,
                token: $setup.token,
                onClose: _cache[4] || (_cache[4] = $event => (_ctx.showBreakoutRoomsEditor = false))
              }, null, 8, ["token"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
  ], 2))
}